import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import MyButton from "../../util/MyButton";
import Media from "react-media";

// MUI Stuff
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import ImageIcon from "@material-ui/icons/Image";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Redux stuff
import { connect } from "react-redux";
import { createPost, clearErrors } from "../../redux/actions/dataActions";

const styles = {
  progress: {
    position: "absolute",
  },
  submitButton: {
    position: "relative",
    float: "right",
    marginTop: "2px",
  },
  characterCount: {
    position: "relative",
    float: "left",
    marginTop: "2px",
    fontSize: "20px",
  },
  progressSpinner: {
    position: "absolute",
  },
  top: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};

const CreatePost = (props) => {
  const [open, setOpen] = useState(false);
  const [body, setBody] = useState("");
  const [errors, setErrors] = useState({});

  const {
    classes,
    UI: { loading },
    clearErrors,
  } = props;

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    clearErrors();
    setOpen(false);
    setErrors({});
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    props.createPost({ body });
  };

  const newErrors = props.UI.errors;

  //Function to check if an objext is empty
  const isEmpty = (obj) => {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false;
      }
    }
    return JSON.stringify(obj) === JSON.stringify({});
  };

  useEffect(() => {
    if (newErrors) {
      setErrors(newErrors);
    }
    if (isEmpty(newErrors) && !loading) {
      setBody("");
      setOpen(false);
      setErrors({});
    }
  }, [newErrors, loading]);

  return (
    <Fragment>
      <MyButton onClick={handleOpen} tip="Create a new Post!">
        <AddIcon />
      </MyButton>
      <Media
        queries={{
          small: "(max-width: 768px)",
        }}
      >
        {(matches) =>
          matches.small ? (
            <Dialog open={open} onClose={handleClose} fullScreen>
              <DialogTitle
                style={{
                  padding: "0",
                }}
              >
                <MyButton
                  tip="Close"
                  onClick={handleClose}
                  className={classes.closeButton}
                >
                  <ArrowBackIcon style={{ color: "#2942ce" }} />
                </MyButton>
              </DialogTitle>
              <Divider variant="fullWidth" />
              <DialogContent>
                <form onSubmit={handleSubmit}>
                  <TextField
                    name="body"
                    type="text"
                    placeholder="Any idea or problem?"
                    error={errors.body ? true : false}
                    helperText={errors.body}
                    onChange={(e) => setBody(e.target.value)}
                    value={body}
                    fullWidth
                    id="outlined-multiline-static"
                    multiline
                    rows={10}
                  />

                  <div
                    className={`${classes.characterCount} ${
                      body.length > 300 ? "red" : ""
                    }`}
                  >
                    {300 - body.length}
                  </div>

                  {body.length > 300 ? (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      disabled
                    >
                      Post
                      {loading && (
                        <CircularProgress
                          size={30}
                          className={classes.progressSpinner}
                        />
                      )}
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      disabled={loading}
                    >
                      Post
                      {loading && (
                        <CircularProgress
                          size={30}
                          className={classes.progressSpinner}
                        />
                      )}
                    </Button>
                  )}
                </form>
              </DialogContent>
            </Dialog>
          ) : (
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
              <DialogTitle
                style={{
                  padding: "0",
                }}
              >
                <MyButton
                  tip="Close"
                  onClick={handleClose}
                  className={classes.closeButton}
                >
                  <CloseIcon style={{ color: "#2942ce" }} />
                </MyButton>
              </DialogTitle>
              <Divider variant="fullWidth" />
              <DialogContent>
                <form onSubmit={handleSubmit}>
                  <TextField
                    name="body"
                    type="text"
                    placeholder="Any idea or problem?"
                    error={errors.body ? true : false}
                    helperText={errors.body}
                    onChange={(e) => setBody(e.target.value)}
                    value={body}
                    fullWidth
                    id="outlined-multiline-static"
                    multiline
                    rows={7}
                  />

                  <div
                    className={`${classes.characterCount} ${
                      body.length > 300 ? "red" : ""
                    }`}
                  >
                    {300 - body.length}
                  </div>

                  {body.length > 300 ? (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      disabled
                    >
                      Post
                      {loading && (
                        <CircularProgress
                          size={30}
                          className={classes.progressSpinner}
                        />
                      )}
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.submitButton}
                      disabled={loading}
                    >
                      Post
                      {loading && (
                        <CircularProgress
                          size={30}
                          className={classes.progressSpinner}
                        />
                      )}
                    </Button>
                  )}
                </form>
              </DialogContent>
            </Dialog>
          )
        }
      </Media>
    </Fragment>
  );
};

CreatePost.propTypes = {
  createPost: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  UI: state.UI,
});

export default connect(mapStateToProps, { createPost, clearErrors })(
  withStyles(styles)(CreatePost)
);

// Limit no of characters in a post and give users feedback e.g. starting point(blue),warning(yellow),
// More than 300 characters :error(red) just like twitter
//Remember users are posting microblogs not blogs or textbook
// Microblogs are short posts for quick audience interactions
